import {Poker2LayoutManager} from "../../Poker2LayoutManager";
import Container = createjs.Container;
import Rectangle = createjs.Rectangle;

export class TutorialHitAreaHelper {

    private static hitArea: Library.PokerInterface.Btn_HitArea;
    private static rect: Rectangle;

    /**
     * Helper hit area, which we add on top of the spotlights.
     * It is needed in the cases when the spotlights cover interactive areas.
     * @param {Rectangle} rect - position of the hit area
     * @param {boolean} isDebug - shows visual rectangle for debug purposes
     * @returns {Container}
     */
    public static addTutorialHitArea(rect: Rectangle, isDebug: boolean = false): Container {
        this.rect = rect;

        if(!this.hitArea) {
            this.hitArea = new Library.PokerInterface.Btn_HitArea();
            this.tutorialLayer.addChildAt(this.hitArea, this.tutorialLayer.children.length);
        }

        this.hitArea.getChildAt(0).visible = isDebug; // show the hit area

        this.updateHitAreaPosition();

        return this.hitArea;
    }

    public static updateHitAreaPosition(): void {
        if(this.hitArea && this.rect) {
            this.hitArea.x = Poker2LayoutManager.getInstance().gameNullPoint + (this.rect.x * Poker2LayoutManager.getInstance().scaleFactor);
            this.hitArea.y = this.rect.y * Poker2LayoutManager.getInstance().scaleFactor;
            this.hitArea.width = this.rect.width * Poker2LayoutManager.getInstance().scaleFactor;
            this.hitArea.height = this.rect.height * Poker2LayoutManager.getInstance().scaleFactor;
        }
    }

    public static removeTutorialHitArea(): void {
        if (this.hitArea) {
            this.hitArea.removeAllEventListeners();
            this.tutorialLayer.removeChildAt(this.tutorialLayer.children.length - 1);

            this.hitArea = null;
            this.rect = null;
        }
    }

    private static get tutorialLayer(): Container {
        return Poker2LayoutManager.getInstance().tutorialLayer;
    }
}
